import React, { useState, useEffect, useCallback } from "react";
import DataFetchHookV3 from "../../helper/DataFetchHookV3";
import CustomPaginationV2 from "../../helper/Table/CustomPaginationV2";
import CustomDateRangeV3 from "../../helper/Table/CustomDateRangeV3";
// import SortOrder from "../../helper/Table/SortOrder"; // commented due to unused var
import { Table, PageHeader, Card, Form, Select, Row, Col, Input, Button, Divider, Space, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";
import { API_TXFRAUD, API_MERCHANT, API_RETAILER, API_SITE } from "../../config/config";
import ColumnResizable from "../../helper/Table/ColumnResizable";
import MergeColumns from "../../helper/Table/MergeColumns";
import GroupAccess from "../../helper/GroupAccess";
import ExportModalV3 from "../../helper/ExportModalV3";
import htmlParser from "html-react-parser";
import FormatAmount from "../../helper/FormatAmount";
import createExportDateHandler from "../../helper/createExportDateHandler";


const { Option } = Select;
const DATA_URL = API_TXFRAUD + "/fraudchecks";
const MERCHANT_DATA_URL = API_MERCHANT + "/list";
const RETAILER_DATA_URL = API_RETAILER + "/list";
const SITE_DATA_URL = API_SITE + "/list";
const DATA_URL_EXPORT = API_TXFRAUD + "/fraudchecks/reports";

const MAX_DATERANGE = 3;
const START_DATE = moment().subtract(MAX_DATERANGE, "months");
const END_DATE = moment();

const FraudcheckList = (props) => {
    //eslint-disable-next-line
    const [{ data, totalResult, isLoading, requestData }, doFetch, setRequestData] = DataFetchHookV3(DATA_URL, "POST", { size: 20, page: 1,
        startDate: START_DATE,
        endDate: END_DATE,
        order: "DESC",
        sort_field: "timestamp" }); // eslint-disable-line
    const [formData, setFormData] = useState();
    // const [sortedInfo, setSortedInfo] = useState({});
    const [dates, setDates] = useState([START_DATE, END_DATE]);
    const [currentPage, setCurrentPage] = useState(1);
    const { t } = props;
    const [isDateExceeded, setIsDateExceeded] = useState(false);
    const [merchantList, setMerchantList] = useState([]);
    const [retailerList, setRetailerList] = useState([]);
    const [siteList, setSiteList] = useState([]);
    const [inactiveChecked, setInactiveChecked] = useState(false);
    const initFormData = {
        txid: "",
        dateRange: [START_DATE, END_DATE],
        status: [],
        merchant: [],
        retailer: [],
        site: [],
        order: "DESC",
        keyword: "",
        field: null,
        sort_field: "timestamp",
        amountoperator: '',
        amountvalue: ''
    };

    const [form] = Form.useForm();

    useEffect(() => {
        formValInit();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getmerchantList = useCallback(() => {
        axios
            .post(
                MERCHANT_DATA_URL,
                { getall: true },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setMerchantList(data.list);
            })
            .catch(() => false);
    }, []);

    const getRetailerList = useCallback((mid_change) => {
        axios
            .post(
                RETAILER_DATA_URL,
                { mid: mid_change },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setRetailerList(data.list);
            })
            .catch(() => false);
    }, []);
    
    const getSiteList = useCallback((mid_change, rid_change) => {
        axios
            .post(
                SITE_DATA_URL,
                { mid: mid_change, rid: rid_change },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setSiteList(data.list);
            })
            .catch(() => false);
    }, []);

    useEffect(() => {
        setFormData(initFormData);
        form.setFieldsValue(initFormData);
        if (merchantList.length === 0) {
            getmerchantList();
        }
        if (retailerList.length === 0) {
            getRetailerList();
        }
        if (siteList.length === 0) {
            getSiteList();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
        // setSortedInfo(sorter);
        var orderBy = 'ASC';
        if(sorter.order === 'descend'){
            orderBy = 'DESC';
        }
        var sortField = 'timestamp';
        if (sorter.field !== undefined){
            sortField = sorter.field;
        }
        var p = pagination.current;
        if (Object.keys(sorter).length >0 && requestData.sort_field !== sortField){
            p = 1;
            setCurrentPage(1);
        }

        setRequestData({ ...requestData, order: orderBy, sort_field: sortField, page: p, size: pagination.pageSize  });
    };

    const columns = [
        {
            dataIndex: "txid",
            key: "txid",
            title: t("tables.fields.txid"),
            fixed: "left",
            width: 110,
            sorter: {
                compare: (a, b) => a.txid - b.txid,
            },
            render: (id, record) => (
                <a href={`/transactions/${id}`} target="_blank" rel="noopener noreferrer">
                    {record.txid}
                </a>
            ),
        },
        {
            dataIndex: "timestamp",
            key: "timestamp",
            title: t("tables.fields.date"),
            width: 120,
            ellipsis: true,
            render: (timestamp) => moment(timestamp).format("lll"),
            sorter: {
                compare: (a, b) => moment(a.timestamp).diff(moment(b.timestamp)),
            },
        },
        {
            dataIndex: "card_no",
            key: "card_no",
            title: t("tables.fields.card_no"),
            width: 100,
            ellipsis: true,
            sorter: {
                compare: (a, b) => String(a.card_no ?? '').localeCompare(String(b.card_no ?? '')),
            },
        },
        {
            dataIndex: "amount",
            key: "amount",
            title: t("tables.fields.amount"),
            width: 60,
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.amount - b.amount,
            },
            render: (amount, record) => FormatAmount(amount, record.currency_code),
        },
        {
            dataIndex: "currency_code",
            key: "currency_code",
            title: t("tables.fields.currency"),
            width: 60,
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.currency_code.localeCompare(b.currency_code),
            },
        },
        {
            dataIndex: "email",
            key: "email",
            title: t("tables.fields.email"),
            width: 100,
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.email.localeCompare(b.email),
            },
        },
        {
            dataIndex: "sitename",
            key: "sitename",
            title: t("tables.fields.sitename"),
            width: 100,
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.sitename.localeCompare(b.sitename),
            },
        },
        {
            dataIndex: "response",
            key: "response",
            title: t("tables.fields.status"),
            width: 100,
            fixed: "right",
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.response.localeCompare(b.response),
            },
        },
    ];
    
    const exportHeadersOptional = [];
    const exportHeaders = [
        { label: "Txid", key: "txid" },
        { label: "Date", key: "date" },
        { label: "Card No.", key: "card_no" },
        { label: "Amount", key: "amount" },
        { label: "Currency", key: "currency_code" },
        { label: "Email", key: "email" },
        { label: "Site Name", key: "site_name" },
        { label: "Status", key: "status" },
        //Txid, Date, Card number, Amount, currency, email, sitename, Status
    ];

    const formValInit = () => {
        setFormData(initFormData);
        form.setFieldsValue(initFormData);
    };

    const clearAll = () => {
        setFormData(initFormData);
        setDates([START_DATE, END_DATE]);
        setRequestData({ ...requestData, ...initFormData, startDate: START_DATE, endDate: END_DATE, page: 1 });
        form.setFieldsValue(initFormData);
    };

    const formValChange = (chgV, allV) => {
        setFormData(allV);
    };

    let mid_select = null;
    let rid_select = null;
    const onChangeMid = (mid_change) => {
        mid_select = mid_change
        getRetailerList(mid_select);
        getSiteList(mid_select, rid_select);
    }

    const onChangeRid = (rid_change) => {
        rid_select = rid_change
        getSiteList(mid_select, rid_select);
    }

    const onFinish = () => {
        let startDate = null;
        let endDate = null;
        let searchData = {};
        if (formData) {
            if (dates) {
                startDate = dates[0] ? dates[0] : null;
                endDate = dates[1] ? dates[1] : null;
            }
            searchData = {
                field: formData.field,
                keyword: formData.keyword ? formData.keyword.trim() : null,
                status: formData.status,
                mid: formData.merchant,
                rid: formData.retailer,
                sid: formData.site,
                order: formData.order ? formData.order : 'ASC',
                amountoperator: formData.amountoperator,
                amountvalue: formData.amountvalue ? formData.amountvalue.trim() : formData.amountvalue,
            };
        }
        // Reset Page Index to 1
        setCurrentPage(1);
        setRequestData({ ...requestData, ...searchData, startDate: startDate, endDate: endDate, page: 1 });
    };

    const onChangeInactive = (e) => {
        setInactiveChecked(e.target.checked);
    };

    const getMerchant = () => {
        if (inactiveChecked) {
            return merchantList.map((item) => (
                item.status === 'active' ?
                    <Option key={item.mid} value={item.mid}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
                    : <Option key={item.mid} value={item.mid} style={{ color: "#f5222d" }}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
            ))
        } else {
            return merchantList.map((item) => (
                item.status === 'active'
                    ?
                    <Option key={item.mid} value={item.mid}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
                    :
                    null
            ))
        }
    };

    /**
     * callback to reflect the changes on dates to the passing request data
     * 
     * @param array values 
     */
    const handleDateChange = createExportDateHandler(requestData);

    const AdvancedSearchForm = () => (
        <div className="search-wrap">
            <Card title={t("tables.actions.search")} size="small">
                <Form form={form} size="large" name="advanced_search" className="ant-advanced-search-form" onValuesChange={formValChange} onFinish={onFinish}>
                    <Row gutter={[16, 16]}>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Form.Item name="dateRange" rules={[
                                    {
                                        validator: () => {
                                            if(isDateExceeded){
                                                return Promise.reject(t('max_3_months'));
                                            }else if((dates[0] && !dates[1]) || (!dates[0] && dates[1])){
                                                return Promise.reject(t('min_1_day'));
                                            }else{
                                                return Promise.resolve();
                                            }
                                        }
                                    }
                                ]}>
                                <CustomDateRangeV3 t={t} setIsDateExceeded={setIsDateExceeded} state={{ dates, setDates }} unit="months" limit={MAX_DATERANGE} onChange={handleDateChange} />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                            <Form.Item name="merchant">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    showArrow="true"
                                    maxTagCount="responsive"
                                    style={{ width: "100%" }}
                                    optionFilterProp="children"
                                    onChange={onChangeMid}
                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                    filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                    placeholder={t("contents.merchants.title")}
                                    dropdownRender={(menu) => GroupAccess("SYSADMIN") ? (
                                        <>
                                            {menu}

                                            <Divider
                                                style={{
                                                    margin: '8px 0',
                                                }}
                                            />
                                            <Space
                                                style={{
                                                    padding: '0 8px 4px',
                                                }}
                                            >
                                                <Checkbox onChange={onChangeInactive}>Show Inactive?</Checkbox>
                                            </Space>
                                        </>
                                    ) : (
                                        <>
                                            {menu}
                                        </>
                                    )}
                                >
                                    {merchantList
                                        ? getMerchant()
                                        : null}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                            <Form.Item name="retailer">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    showArrow="true"
                                    maxTagCount="responsive"
                                    style={{ width: "100%" }}
                                    optionFilterProp="children"
                                    onChange={onChangeRid}
                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                    filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                    placeholder={t("contents.retailers.title")}>
                                    {retailerList
                                        ? retailerList.map((item) => (
                                            <Option key={item.rid} value={item.rid}>
                                                {htmlParser(item.name) + ` (rid: ` + item.rid + `)`}
                                            </Option>
                                        ))
                                        : null}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                            <Form.Item name="site">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    maxTagCount="responsive"
                                    showArrow="true"
                                    style={{ width: "100%" }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                    filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                    placeholder={t("contents.sites.title")}>
                                    {siteList
                                        ? siteList.map((item) => (
                                            <Option key={item.sid} value={item.sid}>
                                                {htmlParser(item.name) + ` (sid: ` + item.sid + `)`}
                                            </Option>
                                        ))
                                        : null}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Row>
                               <Col style={{ width: "50%", paddingRight: '8px' }}>
                                    <Form.Item name="field">
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ width: "100%" }}
                                            placeholder={t("tables.fields.field")}>
                                            <Option value="txid">{t("tables.fields.txid")}</Option>
                                            <Option value="card_no">{t("tables.fields.card_no")}</Option>
                                            <Option value="email">{t("tables.fields.email")}</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col style={{ width: "50%", paddingLeft: '8px' }}>
                                    <Form.Item name="keyword">
                                        <Input placeholder={t("tables.fields.keyword")} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Form.Item name="status">
                                <Select mode="multiple" maxTagCount="responsive" allowClear style={{ width: "100%" }} placeholder={t("tables.fields.status")}>
                                    <Option value="APPROVED">APPROVED</Option>
                                    <Option value="DECLINED">DECLINED</Option>
                                    <Option value="PAYG_ERROR">PAYG_ERROR</Option>
                                    <Option value="PENDING">PENDING</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 6 }}>
                            <Row>
                                <Col style={{ width: "30%", paddingRight: '5px' }}>
                                    <Form.Item name="amountoperator">
                                        <Select maxTagCount="responsive" >
                                            <Option value="=">{'='}</Option>
                                            <Option value=">">{'>'}</Option>
                                            <Option value="<">{'<'}</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col style={{ width: "70%" }}>
                                    <Form.Item name="amountvalue">
                                        <Input placeholder={t("tables.fields.amount")} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col className="gutter-row"  xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6, offset: 12 }} lg={{ span: 6, offset: 12 }} xl={{ span: 3, offset: 17 }}>
                            <Form.Item>
                                <Button type="secondary" onClick={() => clearAll()} block>
                                    {t("tables.actions.clear_all")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    <SearchOutlined /> {t("tables.actions.search")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );

    const getDataSource = (datalist) => (datalist && Array.isArray(datalist) ? datalist : []);

    const getHeaderTable = () => (
        <div className="custom-table--header d-flex justify-content-between align-items-center">
            <h3 className="table-title">{t("contents.fraudchecks.title")}</h3>
            <ExportModalV3
                t={t}
                keyname="export_all"
                title={t("tables.actions.export")}
                data={requestData}
                data_url={DATA_URL_EXPORT}
                headers={exportHeaders}
                fieldHeadersOptional={exportHeadersOptional}
                filename={`fraudcheck_${moment().format("YYMMDD_HHmmss_SSSS")}.csv`}
                style={{ marginLeft: 8 }}
            />
        </div>
    );

    return (
        <div>
            <PageHeader title={t("contents.fraudchecks.title")}></PageHeader>
            {AdvancedSearchForm()}
            <Table
                loading={isLoading}
                rowKey="txid"
                title={() => getHeaderTable()}
                components={{
                    header: {
                        cell: ColumnResizable,
                    },
                }}
                columns={MergeColumns(columns)}
                size="small"
                scroll={{ x: 1500 }}
                className="table-v3 custom-pagination"
                dataSource={getDataSource(data.datalist)}
                onChange={handleChange}
                sortDirections={["ascend", "descend"]}
                pagination={CustomPaginationV2({ totalResult, currentPage, requestData, setRequestData, setCurrentPage })}
            />
        </div>
    );
};

export default FraudcheckList;
